import script from "./DC.vue?vue&type=script&lang=js"
export * from "./DC.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__